import React from 'react';
import { FormattedMessage } from 'react-intl';
import IconHouse from '../../icons/3d-house.svg';

const FlatsMapLabel = () => (
  <div className="FlatsMapLabel MapLabel">
    <div className="MapLabel-icon">
      <IconHouse />
    </div>
    <div className="MapLabel-content">
      <FormattedMessage id="selectHouse" />
    </div>
  </div>
);

export default FlatsMapLabel;
